export function scrollDialogToEnd() {
  document.querySelector('mat-dialog-content').scrollBy(0, 1000000);
}
